import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Subject} from 'rxjs/Subject';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';

import {RegAlarma} from './regAlarma';

import myGlobals = require('../config');

var moment = require('moment');

@Injectable()
export class RegAlarmaService {

    private regAlarmaUrl = myGlobals.default.BASE_URL + '/regAlarma/';  // URL to web api

    constructor(private http: Http) {
    }

    // Observable string sources
    private notificaciones = new Subject<[RegAlarma]>();
    // Observable string streams
    notificaciones$ = this.notificaciones.asObservable();

    //Obtener todos los regAlarmas
    getRegAlarmas() {
        return this.http.get(this.regAlarmaUrl)
            .map((response) => response.json());
    }

    //Obtener un regAlarma por sensor
    getRegAlarmaActivadasPorSensor(_idSensor: string): Observable<RegAlarma[]> {
        return this.http.get(this.regAlarmaUrl + _idSensor)
            .map((response) => response.json());
    }

    //Obtener un regAlarma por sensor
    getRegAlarmaActivadasPorNodo(_idNodo: string): Observable<RegAlarma[]> {
        return this.http.get(this.regAlarmaUrl + _idNodo + "/nodo")
            .map((response) => response.json());
    }

    //Obtener regAlarmas by sensor y fechas
    getRegAlarmasBySensorYFecha(_id: string, fechaDesde: Date, fechaHasta: Date, offset: string): Observable<RegAlarma[]> {
        if (!offset)
            offset = "-03:00"
        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
        return this.http.get(this.regAlarmaUrl + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr)
            .map((response) => response.json());
    }

    //Obtener regAlarmas by sensor y fechas
    getRegAlarmasByNodoYFecha(_id: string, fechaDesde: Date, fechaHasta: Date, offset: string): Observable<RegAlarma[]> {
        if (!offset)
            offset = "-03:00"
        var fechaDesdeStr = moment(fechaDesde).utcOffset(offset).startOf("day").format();
        var fechaHastaStr = moment(fechaHasta).utcOffset(offset).endOf('day').format();
        return this.http.get(this.regAlarmaUrl + _id + "/" + fechaDesdeStr + "/" + fechaHastaStr + "/nodo")
            .map((response) => response.json());
    }

    //Obtener regAlarmas activadas
    getAllRegAlarmasActivadas(): Observable<RegAlarma[]> {
        return this.http.get(this.regAlarmaUrl + "todo/todo")
            .map((response) => {
                this.notificaciones.next(response.json());
                return response.json();
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/regAlarma/regAlarma.service.ts